import { Currency } from './Currency';

export interface NonExchangeDay {
    id: number;
    name: string;
    date: string;
    period: string;
    currencies: Currency[];
    is_active: boolean;
    created_at?: string;
    updated_at?: string;
}

export interface NonExchangeDayFilters {
    page: number;
    per_page: number;
    sort: string;
    order: string;
    name?: string;
    period?: string;
}

export const defaultNonExchangeDay: NonExchangeDay = {
    id: 0,
    name: '',
    date: '',
    period: '',
    currencies: [],
    is_active: true,
}; 